import useSearchParams from "hooks/useSearchParams";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

const usePhysicalBooksFilters = () => {
	const [firstPage, setFirstPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [page, setPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");
	const [categoryIs, setCategoryIs] = useState("");
	const [genreIs, setGenreIs] = useState("");

	const { getParam, setParam, deleteParam, hasParam } = useSearchParams();
	const { push } = useHistory();
	const { pathname } = useLocation();

	useEffect(() => {
		if (hasParam("page")) {
			const pageParam = getParam("page")?.length > 0 ? getParam("page") : 1;
			setPage(pageParam);
		}
		if (hasParam("rows")) {
			const rowsPerPageParam =
				getParam("rows")?.length > 0 ? getParam("rows") : 20;
			setRowsPerPage(rowsPerPageParam);
		}
		if (hasParam("first_page")) {
			const firstPageParam =
				getParam("first_page")?.length > 0 ? getParam("first_page") : 0;
			setFirstPage(firstPageParam);
		}
		if (hasParam("search_term")) {
			const searchTermParam =
				getParam("search_term")?.length > 0 ? getParam("search_term") : "";
			setSearchTerm(searchTermParam);
		}
		if (hasParam("category_is")) {
			const categoryIsParam =
				getParam("category_is")?.length > 0 ? getParam("category_is") : "";
			setCategoryIs(categoryIsParam);
		}
		if (hasParam("genre_is")) {
			const genreIsParam =
				getParam("genre_is")?.length > 0 ? getParam("genre_is") : "";
			setGenreIs(genreIsParam);
		}

		return () => {
			deleteParam("page");
			deleteParam("rows");
			deleteParam("first_page");
			deleteParam("search_term");
			deleteParam("category_is");
			deleteParam("genre_is");
		};
	}, [hasParam, getParam, deleteParam]);

	const changeFilter = (key, value) => {
		switch (key) {
			case "page":
				if (value?.length <= 0) {
					const q = deleteParam("page");
					setPage(1);
					return push(`${pathname}?${q}`);
				}
				const pageQuery = setParam("page", value);
				push(`${pathname}?${pageQuery}`);
				break;

			case "rowsPerPage":
				if (value?.length <= 0) {
					const q = deleteParam("rows");
					setRowsPerPage(20);
					return push(`${pathname}?${q}`);
				}
				const rowsQuery = setParam("rows", value);
				push(`${pathname}?${rowsQuery}`);
				break;

			case "firstPage":
				if (value?.length <= 0) {
					const q = deleteParam("first_page");
					setFirstPage(0);
					return push(`${pathname}?${q}`);
				}
				const firstPageQuery = setParam("first_page", value);
				push(`${pathname}?${firstPageQuery}`);
				break;

			case "searchTerm":
				if (value?.length <= 0) {
					const q = deleteParam("search_term");
					setSearchTerm("");
					return push(`${pathname}?${q}`);
				}
				const searchQuery = setParam("search_term", value);
				push(`${pathname}?${searchQuery}`);
				break;

			case "categoryIs":
				if (value?.length <= 0) {
					const q = deleteParam("category_is");
					setCategoryIs("");
					return push(`${pathname}?${q}`);
				}
				const categoryQuery = setParam("category_is", value);
				push(`${pathname}?${categoryQuery}`);
				break;

			case "genreIs":
				if (value?.length <= 0) {
					const q = deleteParam("genre_is");
					setGenreIs("");
					return push(`${pathname}?${q}`);
				}
				const genreQuery = setParam("genre_is", value);
				push(`${pathname}?${genreQuery}`);
				break;

			default:
				break;
		}
	};

	return {
		firstPage,
		rowsPerPage,
		page,
		searchTerm,
		categoryIs,
		genreIs,
		changeFilter,
	};
};

export default usePhysicalBooksFilters;
